export default __webpack_public_path__ + "static/media/money.fbe7b363.png";